module.exports = __webpack_public_path__ + "img/settings-user-accounts.5a2cbeba.svg";